
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/kommo",
      function () {
        return require("private-next-pages/destinations/kommo.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/kommo"])
      });
    }
  